import Scriba from 'react-scriba';

export const TYPES_DOCUMENT = {
    OPERATION: "Operation",
    RESERVATION: "Reservation",
    LOT: "Lot",
};

export class DataDocument {

    static _chargementDocument(rowGUID, idLot, idOperation, idAgence, idRegion) {
        let objet = {
            "rowGUID": rowGUID,
            "idLot": idLot,
            "idOperation": idOperation,
            "idAgence": idAgence,
            "idRegion": idRegion
        };

        var url = "api/Fiche/FicheDocument";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementDocument(type, document) {
        let objet = {
            "type": type,
            "document": document
        };

        var url = "api/MAJDonnees/EnregistrementDocument";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onTelechargementDocument = (rowGUID) => {
        const objet = { rowGUID };
        const url = "api/SignatureElectronique/TelechargementDocument";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementImportDocument(documentEnCours, idOperationPerimetre, idAgencePerimetre, idRegionPerimetre, idReservation) {
        let objet = {
            "document": documentEnCours,
            "idOperation": idOperationPerimetre,
            "idAgence": idAgencePerimetre,
            "idRegion": idRegionPerimetre,
            "idReservation": idReservation
        };

        /* 20230224 : YD : injection dependance Agence */
        var url = "api/v2/MAJDonnees/EnregistrementImportDocument";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesDocumentsDuPerimetreSelectionne(facteurNbreEnregistrement, origine, filtreType, filtreIdCategorie, filtreIdSousCategorie, filtreNational, filtreRegion, filtreAgence, filtreOperation, filtreLot, tri, pageIndex) {
        let objet = {
            "nbreEnreg": facteurNbreEnregistrement,
            "origine": origine,
            "filtreType": filtreType,
            "filtreIdCategorie": filtreIdCategorie,
            "filtreIdSousCategorie": filtreIdSousCategorie,
            "filtreNational": filtreNational,
            "filtreRegion": filtreRegion,
            "filtreAgence": filtreAgence,
            "filtreOperation": filtreOperation,
            "filtreLot": filtreLot,
            "tri": tri,
            "pageIndex": pageIndex
        };

        var url = "api/Liste/ListeDesDocumentsDuPerimetreSelectionne";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesDocuments = (filtres) => {
        const objet = { filtres };
        const url = "api/Liste/ListeDesDocuments";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionDocument(documents) {
        let objet = {
            "documents": documents
        };

        /* 20230224 : YD : RegionMetier */
        let url = "api/v2/MAJDonnees/SuppressionDocument";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onUpdateWordModel = (comments, fileData, fileName) => {
        const objet = { comments, fileData, fileName };
        const url = "api/Download/UpdateWordModel";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onImportComments = (fileData, fileName) => {
        const objet = { fileData, fileName };
        const url = "api/Download/ImportWordComments";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onPublipostageTest = (fileData, fileName, idOperation, idReservation, where) => {
        const objet = { fileData, fileName, idOperation, idReservation, where };
        const url = "api/Download/PubliposterTest";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onTelechargementDocuments = (perimetre, idsOperations, idDocumentOperationType, idDocumentReservationType, idDocumentLotType) => {
        const objet = { perimetre, idsOperations, idDocumentOperationType, idDocumentReservationType, idDocumentLotType };
        const url = "api/Download/TelechargerDocuments";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

};